import { render, staticRenderFns } from "./FormBeneficios.vue?vue&type=template&id=7c2ee7db"
import script from "./FormBeneficios.vue?vue&type=script&lang=js"
export * from "./FormBeneficios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports